import { createSlice } from "@reduxjs/toolkit";

export enum ScreensList {
  ADMIN = "Admin",
  STUDIO = "Studio",
  SERVICES = "Services",
  EMPLOYEES = "Employees",
  BOOKINGS = "Bookings",
}

interface SetEmptyStateScreenActionType {
  payload: {
    key: ScreensList;
    value: boolean;
  };
}

const emptyScreens = createSlice({
  name: "emptyScreens",
  initialState: {
    [ScreensList.ADMIN]: {
      isShouldShowEmptyState: true,
    },
    [ScreensList.STUDIO]: {
      isShouldShowEmptyState: true,
    },
    [ScreensList.SERVICES]: {
      isShouldShowEmptyState: true,
    },
    [ScreensList.EMPLOYEES]: {
      isShouldShowEmptyState: true,
    },
    [ScreensList.BOOKINGS]: {
      isShouldShowEmptyState: true,
    },
  },
  reducers: {
    setEmptyStateScreen: (
      state,
      { payload: { key, value } }: SetEmptyStateScreenActionType
    ) => {
      state[key].isShouldShowEmptyState = value;
    },
  },
});

export const { setEmptyStateScreen } = emptyScreens.actions;

export default emptyScreens.reducer;
